var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_907_85027)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16.1875,
    width: 20,
    height: 2.16216,
    fill: "#CCCFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1377 4.29688L13.0937 12.6487L12.0497 12.6487L11.0057 12.6487L9.96176 4.29687L14.1377 4.29688Z",
    fill: "#CCCFD1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65918 14.7435C2.65918 10.6039 5.33628 7.0895 9.05366 5.83723L9.77469 11.6055H10.8817L10.1243 5.54623C10.7474 5.41608 11.3932 5.34766 12.055 5.34766C12.7185 5.34766 13.366 5.41643 13.9906 5.54723L13.2333 11.6055H14.3295L15.0551 5.83679C18.7732 7.08866 21.4509 10.6034 21.4509 14.7435H2.65918Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_907_85027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelmet);
export default __webpack_public_path__ + "static/media/icon-helmet.77336e3297a02adb2f9a0005fe6f66b4.svg";
export { ForwardRef as ReactComponent };